import { render } from "./purchaseinvoice.vue?vue&type=template&id=91dc261e"
import script from "./purchaseinvoice.vue?vue&type=script&lang=js"
export * from "./purchaseinvoice.vue?vue&type=script&lang=js"

import "./purchaseinvoice.vue?vue&type=style&index=0&id=91dc261e&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__